export type RecordsPdfRedactionKeywordCategory = {
  id: string
  label: string
  keywords: readonly string[]
}

export const RECORDS_PDF_REDACTION_KEYWORD_CATEGORIES = [
  {
    id: 'hiv-aids',
    label: 'HIV / AIDS',
    keywords: [
      'HIV',
      'AIDS',
      'HIV+',
      'HIV positive',
      'HIV-positive',
      'HIV status',
      'HIV diagnosis',
      'seroconversion',
      'seropositive',
      'Post-exposure prophylaxis',
      'PEP',
      'pre-exposure prophylaxis',
      'PrEP',
      'antiretroviral',
      'antiretrovirals',
      'HAART',
      'cART',
      'protease inhibitor',
      'integrase inhibitor',
      'Truvada',
      'Descovy',
      'Biktarvy',
      'Atripla',
      'Genvoya',
      'Tivicay',
      'Triumeq',
      'Isentress',
      'Stribild',
      'Complera',
      'Odefsey',
      'Symtuza',
      'Sustiva',
      'Norvir',
      'Prezista',
      'Reyataz',
      'Edurant',
      'Selzentry',
      'Fuzeon',
      'tenofovir',
      'emtricitabine',
      'dolutegravir',
      'raltegravir',
      'efavirenz',
      'rilpivirine',
      'abacavir',
      'lamivudine',
      'darunavir',
      'atazanavir',
      'bictegravir',
      'lopinavir',
      'Viral load',
      'viral suppression',
      'undetectable',
      'CD4',
      'CD4 count',
      'CD4 cell',
      'CD8',
      'CD4/CD8',
      'HIV RNA',
      'HIV-RNA',
      'plasma viremia',
      'HIV-1',
      'opportunistic infection',
      'Kaposi',
      "Kaposi's sarcoma",
      'Pneumocystis',
      'Mycobacterium avium',
      'wasting syndrome',
      'AIDS-defining',
      'HIV history',
      'HIV care',
      'Ryan White',
      'infectious disease clinic',
      'ID clinic',
      'HIV specialist',
      'Apretude',
      'ART adherence',
      'AIDS-related complex',
      'AIDS survivor',
      'Cabenuva',
      'CD4 percentage',
      'CMV retinitis',
      'Evotaz',
      'HIV dementia',
      'HIV encephalopathy',
      'HIV exposure',
      'HIV prevention',
      'HIV screening',
      'HIV test',
      'HIV viral load',
      'HIV-1 viral load',
      'HIV-2 viral load',
      'HIV-associated neurocognitive disorder',
      'HIV-related stigma',
      'Immune Reconstitution Inflammatory Syndrome',
      'Juluca',
      'Prezcobix',
      'Rukobia',
      'Sunlenca',
      'Symfi',
      'Trogarzo',
      'Tybost',
      'Vocabria',
      'Western blot',
      'anxiety related to HIV',
      'cabotegravir',
      'cobicistat',
      'concerns about seroconverting',
      'confirmed HIV positive',
      'coping with HIV diagnosis',
      'cryptococcal meningitis',
      'depression related to HIV',
      'disclosed HIV status',
      'elite controller',
      'fear of disclosure',
      'fostemsavir',
      'genotypic resistance testing',
      'ibalizumab',
      'lenacapavir',
      'lipodystrophy',
      'living with HIV',
      'long-term survivor',
      'medication adherence for HIV',
      'missed doses of ART',
      'mother-to-child transmission',
      'newly diagnosed with HIV',
      'non-adherent to ART',
      'on antiretroviral therapy',
      'opportunistic illness',
      'oral hairy leukoplakia',
      "partner's HIV status",
      'pill fatigue',
      'progressive multifocal leukoencephalopathy',
      'rapid HIV test',
      'received an HIV diagnosis',
      'risk of HIV transmission',
      'serodiscordant',
      'serosorting',
      'serostatus',
      'started on ART',
      'toxoplasmosis',
      'treatment as prevention',
      'undetectable equals untransmittable',
      'vertical transmission',
      'viral rebound',
      'viremic controller',
      'Client HIV status',
      'Patient HIV status',
      'Last HIV test',
      'HIV diagnosis date',
      'HIV testing history',
      'HIV risk factors',
      'Family history of HIV/AIDS',
      'Currently on ART',
    ],
  },
  {
    id: 'genetic-testing',
    label: 'Genetic Testing',
    keywords: [
      'BRCA1',
      'BRCA2',
      'BRCA1/2',
      'BRCA',
      'Lynch syndrome',
      'Li-Fraumeni',
      'Cowden syndrome',
      'Peutz-Jeghers',
      'Hereditary breast and ovarian',
      'Familial adenomatous polyposis',
      'von Hippel-Lindau',
      'Huntington',
      "Huntington's disease",
      'Huntington disease',
      'neurofibromatosis',
      'tuberous sclerosis',
      'Marfan',
      'Hereditary',
      'hereditary cancer',
      'hereditary syndrome',
      'Chromosomal',
      'chromosomal abnormality',
      'Genetic Counseling',
      'genetic counselor',
      'Genetic',
      'germline',
      'germline mutation',
      'germline variant',
      'somatic mutation',
      'carrier status',
      'carrier testing',
      'variant of unknown significance',
      'pathogenic',
      'likely pathogenic',
      'likely benign',
      'founder mutation',
      'next generation sequencing',
      'whole exome',
      'whole genome',
      'karyotype',
      'microarray',
      'comprehensive genomic profiling',
      'panel testing',
      'multigene panel',
      'genetic test',
      'genetic testing',
      'genetic risk',
      'genetic predisposition',
      'family history of cancer',
      'tested positive for',
      'positive carrier',
      '23andMe health report',
      'abnormal genetic result',
      'anxiety about genetic results',
      'Ashkenazi Jewish panel',
      'at-home DNA test',
      'Austedo',
      'cancer gene',
      'carries the gene',
      'cascade screening',
      'cfDNA',
      'chromosome analysis',
      'coping with genetic diagnosis',
      'Cystic Fibrosis',
      'decisional conflict about testing',
      'Deutetrabenazine',
      'direct-to-consumer genetic test',
      'disclosing results to family',
      'Down syndrome',
      'Duchenne muscular dystrophy',
      'Edwards syndrome',
      'Ehlers-Danlos syndrome',
      'expanded carrier screening',
      'family history of genetic disorder',
      'fear of a positive result',
      "found out I'm a carrier",
      'Fragile X syndrome',
      'gene mutation',
      'genetic condition runs in the family',
      'has the mutation',
      'Hemochromatosis',
      'history of genetic condition',
      'impact of genetic diagnosis',
      'informed consent for genetic testing',
      'met with genetic counselor',
      'Myotonic dystrophy',
      'negative for the gene',
      'passed the gene',
      'Patau syndrome',
      'positive for the gene',
      'post-test counseling',
      'pre-test counseling',
      'predictive testing',
      'preimplantation genetic diagnosis',
      'presymptomatic testing',
      'prophylactic mastectomy',
      'prophylactic oophorectomy',
      'prophylactic surgery',
      'received genetic results',
      'referred for genetic counseling',
      'risk-reducing surgery',
      'Sickle cell anemia',
      'Spinal muscular atrophy',
      'stress related to genetic testing',
      "survivor's guilt",
      'Tay-Sachs disease',
      'tested for the gene',
      'Tetrabenazine',
      'Trisomy 13',
      'Trisomy 18',
      'Trisomy 21',
      'underwent genetic testing',
      'waiting for genetic results',
      'Xenazine',
      '22q11.2 deletion syndrome',
      'Retts syndrome',
      'Retts',
      'Rett',
      'Rett Syndrome',
      "Rett's syndrome",
      'Genetic testing done',
      'BRCA testing',
      'Hereditary conditions in family',
      'Family history of hereditary disease',
    ],
  },
  {
    id: 'alcohol-substance-use',
    label: 'Alcohol & Substance Use',
    keywords: [
      'alcohol use disorder',
      'substance use disorder',
      'opioid use disorder',
      'stimulant use disorder',
      'cannabis use disorder',
      'Withdrawal',
      'Relapse',
      'Detox',
      'detoxification',
      'Sobriety Date',
      'sober',
      'sobriety',
      'abstinent',
      'abstinence',
      'in recovery',
      'post-acute withdrawal',
      'delirium tremens',
      'Substance Use',
      'Alcohol',
      'Cannabis',
      'Marijuana',
      'Tobacco',
      'Stimulant',
      'ethanol',
      'heroin',
      'fentanyl',
      'methamphetamine',
      'cocaine',
      'crack',
      'ecstasy',
      'ketamine',
      'benzodiazepine',
      'benzo',
      'barbiturate',
      'opiate',
      'opioid',
      'amphetamine',
      'hallucinogen',
      'inhalant',
      'psilocybin',
      'Adderall',
      'Xanax',
      'Klonopin',
      'Ativan',
      'Valium',
      'Vicodin',
      'Percocet',
      'OxyContin',
      'oxycodone',
      'hydrocodone',
      'tramadol',
      'kratom',
      'Suboxone',
      'Methadone',
      'Naltrexone',
      'Buprenorphine',
      'Vivitrol',
      'Antabuse',
      'Acamprosate',
      'Campral',
      'Sublocade',
      'Zubsolv',
      'naloxone',
      'Narcan',
      'Addicted',
      'Addiction',
      'dependency',
      'dependence',
      'tolerance',
      'intoxicated',
      'intoxication',
      'blackout',
      'binge',
      'binges',
      'binge drinking',
      'binge use',
      'craving',
      'cravings',
      'use disorder',
      'polysubstance',
      'IV drug use',
      'injection drug use',
      'needle use',
      'track marks',
      'overdose',
      'near-overdose',
      'AA meeting',
      'NA meeting',
      '12-step',
      'sponsor',
      'home group',
      'rehab',
      'residential treatment',
      'intensive outpatient',
      'partial hospitalization',
      'medication-assisted treatment',
      'history of substance',
      'history of alcohol',
      'history of drug',
      'denies use',
      'active use',
      'active addiction',
      'in active addiction',
      'drug history',
      'alcohol history',
      'drug-related',
      'Librium',
      'chlordiazepoxide',
      'Ritalin',
      'methylphenidate',
      'Vyvanse',
      'Dilaudid',
      'hydromorphone',
      'Subutex',
      'bath salts',
      'history of polysubstance use',
      'drug of choice',
      'drug seeking behavior',
      'denies IV drug use',
      'reports daily use',
      'age of first use',
      'date of last use',
      'pattern of use',
      'problem drinking',
      'heavy drinking',
      'daily drinker',
      'clean and sober',
      'clean date',
      'drug court',
      'drug-induced psychosis',
      'alcohol-induced',
      'withdrawal symptoms',
      'seizure precautions',
      'Wernicke-Korsakoff syndrome',
      'harm reduction',
      'needle exchange',
      'sober living',
      'halfway house',
      'recovery community',
      'relapse prevention',
      'triggers for use',
      'urine toxicology',
      'drug screen',
      'breathalyzer',
      'methadone clinic',
      'Suboxone clinic',
      'contingency management',
      'motivational interviewing',
      'admits to using',
      'denies current use',
      'endorses cravings',
      'positive for opiates',
      'positive for THC',
      'positive for cocaine',
      'positive for amphetamines',
      'positive for benzodiazepines',
      'dual diagnosis',
      'co-occurring disorder',
      'history of relapse',
      'route of administration',
      'blood alcohol concentration',
      'speedball',
      'shooting up',
      'dope sick',
      'nodding out',
      'cold turkey',
      'getting clean',
      'rock bottom',
      'last drink',
      'history of blackouts',
      'controlled substance',
      'opiate replacement therapy',
      'drug paraphernalia',
      'inhalents',
      'freebase',
      'salvia',
      'cannabidiol',
      'bars',
      'xanibars',
      'sober-living',
      'magic mushroom',
      'bup',
      '7-OH',
      '7OH',
      'ETOH',
      'Al-Anon',
      'Alateen',
      'DUI',
      'DWI',
      'OWI',
      'DUII',
      'OUI',
      'DWAI',
      'ADUI',
      'OUID',
      'OVI',
      'APC',
      'CBD',
      'drink',
      'drinks',
      'smoke',
      'cigarette',
      'cigarettes',
      'drug',
      'drugs',
      'addict',
      'eye-opener',
      'eye opener',
      'alcohol education',
      'substance education',
      'driving under the influence',
      'driving while intoxicated',
      'driving while impaired',
      'operating while intoxicated',
      'operating under the influence',
      'underage drinking',
      'not negative',
      'drug/alcohol violation',
      'drug-free workplace',
      'Client drinks',
      'Client drinks per day',
      'Client binges',
      'Client uses tobacco products',
      'Client uses prescription pills for non-medical reasons',
      'Client uses illicit drugs',
      'Client uses cannabis',
      'Additional Substance Use History Details',
      'Substance Use History',
    ],
  },
] as const satisfies readonly RecordsPdfRedactionKeywordCategory[]
